import { type PropsWithChildren, type ReactElement } from 'react'
import { ParcelTapeIllustration } from '@dhl-ui/illustrations'
import type { BaseProps, MinimalSxPadding } from '../../types'
import { spacing, useIsMobileVariant } from '../../theme'
import { Box } from '../Box'
import { Body1, H5 } from '../Typography'
import { StackColumn } from '../Stack'

type InnerProps = PropsWithChildren<{
  /**
   * Our default is the ParcelTape illustration
   */
  illustration?: ReactElement
}> &
  BaseProps<HTMLElement, MinimalSxPadding | 'maxWidth'>

export type BlazeProps = InnerProps &
  ({ title: string; description?: string | ReactElement } | { title?: string; description: string | ReactElement })

export const Blaze = ({ children, illustration, title, description, sx, ...props }: BlazeProps) => {
  const isMobileVariant = useIsMobileVariant()

  return (
    <Box
      {...props}
      sx={{
        ...sx,
        p: spacing(0, 2),
        maxWidth: spacing(isMobileVariant ? 45 : 64),
      }}
    >
      <StackColumn gap={3} sx={{ textAlign: 'center', display: 'flex', alignItems: 'center' }}>
        <Box sx={{ maxWidth: spacing(30) }}>{illustration || <ParcelTapeIllustration />}</Box>
        <Box>
          <H5>{title}</H5>
          {description && <Body1>{description}</Body1>}
        </Box>
        {children}
      </StackColumn>
    </Box>
  )
}
